module.exports = __webpack_public_path__ + "static/media/notification.828599bf.mp3";